import { PCFooter } from '@commonPackage/components';
import { MetaConfig } from '@portalCommon/components';
import { RouterConfigEnum } from '@portalCommon/constants';

import { Back2Top, Contact, ContactBox, NavHeader } from '@/components';

import AboutFuxi from './AboutFuxi';
import AboutYaotai from './AboutYaotai';

export enum KnownType {
  YAO_TAI = 'yaotai',
  FU_XI = 'fuxi',
}

export default function KnowUs() {
  return (
    <>
      <MetaConfig routerPath={RouterConfigEnum.KnowUs} />
      <NavHeader isStatic mode="white" />
      <AboutYaotai />
      <AboutFuxi />
      <Contact />
      <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} />
      <ContactBox />
      <Back2Top />
    </>
  );
}
